import { useEffect } from "react";
import SpecificCompaniesDisplay from "./SpecificCompaniesDisplay";
import useCompanyNameHandling from "../../../../reactHooks/useCompanyNameHandling";

interface ISpecificCompaniesPromptSection {
  specificCompanies: string[];
  setSpecificCompanies: (companies: string[]) => void;
}

const SpecificCompaniesPromptSection = ({
  specificCompanies,
  setSpecificCompanies,
}: ISpecificCompaniesPromptSection) => {
  const { removeCompany, clearCompanies, updateCompanies } =
    useCompanyNameHandling({
      initialCompanies: specificCompanies,
      onChange: setSpecificCompanies,
    });

  useEffect(() => {
    updateCompanies(specificCompanies);
  }, [specificCompanies, updateCompanies]);

  if (specificCompanies.length <= 0) {
    return null;
  }

  return (
    <SpecificCompaniesDisplay
      specificCompanies={specificCompanies}
      onRemoveCompany={removeCompany}
      onClearAll={clearCompanies}
    />
  );
};

export default SpecificCompaniesPromptSection;
